import ExtendableError from '../lib/ExtendableError';

export class RefreshTokenError extends ExtendableError {
    constructor () {
        super();

        this.message = 'Refresh token error';
    }

    name = 'RefreshTokenError';
}
